/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React from 'react';
import { Page, Text, View, Document, Image } from '@react-pdf/renderer';
import NumberFormat from '../../utils/NumberFormat';
import { formatDate } from '../../utils/formatDate';
import logo from '../../assets/img/frota_maxima.png';
import styles from './styled';

function PDFContent({ viagens, dtinicial, dtfinal, totalizador }) {
  const currentDate = new Date();
  const formattedDate = `${currentDate
    .getDate()
    .toString()
    .padStart(2, '0')}/${(currentDate.getMonth() + 1)
    .toString()
    .padStart(2, '0')}/${currentDate.getFullYear()}`;

  // Paginação: 5 cards por linha, 3 linhas por página = 15 cards por página
  const cardsPerPage = 15;
  const pages = [];
  const totalCards = [...viagens, { isTotalizer: true }]; // Adiciona o totalizador como um card extra

  for (let i = 0; i < totalCards.length; i += cardsPerPage) {
    pages.push(totalCards.slice(i, i + cardsPerPage));
  }

  return (
    <Document>
      {pages.map((pageCards, pageIndex) => (
        <Page
          key={pageIndex}
          size="A4"
          orientation="landscape"
          style={styles.page}
          render={({ pageNumber, totalPages }) => (
            <>
              {/* Cabeçalho em todas as páginas */}
              <View style={styles.headerContainer}>
                <Image style={styles.logo} src={logo} alt="Frota Máxima" />
                <Text style={styles.header}>
                  DRE - Período {formatDate(dtinicial)} à {formatDate(dtfinal)}
                </Text>
                <Text style={styles.date}>{formattedDate}</Text>
                <Text>
                  {pageNumber} / {totalPages}
                </Text>
              </View>

              {/* Conteúdo da página com os cards */}
              <View style={styles.cardContainer}>
                {pageCards.map((viagem, index) =>
                  viagem.isTotalizer ? (
                    <View
                      style={styles.card}
                      key={`totalizer-${index}`}
                      wrap={false}
                    >
                      <View style={styles.section}>
                        <Text style={styles.label}>Totalizador</Text>
                      </View>
                      <View style={styles.section}>
                        <Text style={styles.label} />
                      </View>
                      <View style={styles.section}>
                        <Text style={styles.label} />
                      </View>
                      <View style={styles.divider} />
                      <View style={styles.section}>
                        <Text style={styles.label}>Receitas (R$):</Text>
                        <Text style={styles.value}>
                          {NumberFormat(totalizador.total_receitas)}
                        </Text>
                      </View>
                      <View style={styles.section}>
                        <Text style={styles.label}>Comissão (R$):</Text>
                        <Text style={styles.value}>
                          {NumberFormat(totalizador.total_comissao)}
                        </Text>
                      </View>
                      <View style={styles.section}>
                        <Text style={styles.label}>Result. Líquido (R$):</Text>
                        <Text style={styles.value}>
                          {NumberFormat(totalizador.lucro)}
                        </Text>
                      </View>
                      <View style={styles.section}>
                        <Text style={styles.label}>Result. Líquido (%):</Text>
                        <Text style={styles.value}>
                          {NumberFormat(totalizador.lucro_bruto)}
                        </Text>
                      </View>
                    </View>
                  ) : (
                    <View style={styles.card} key={index}>
                      <View style={styles.section}>
                        <Text style={styles.label}>
                          Veículo: {viagem.placa}
                        </Text>
                        <Text style={styles.value}>{viagem.carreta}</Text>
                      </View>
                      <View style={styles.section}>
                        <Text style={styles.value}>
                          {viagem.nome.split(' ')[0]}
                        </Text>
                      </View>
                      <View style={styles.divider} />
                      <View style={styles.section}>
                        <Text style={styles.label}>Receitas (R$):</Text>
                        <Text style={styles.value}>
                          {NumberFormat(viagem.total_receitas)}
                        </Text>
                      </View>
                      <View style={styles.section}>
                        <Text style={styles.label}>Diesel (R$):</Text>
                        <Text style={styles.value}>
                          {NumberFormat(viagem.total_combustivel)}
                        </Text>
                      </View>
                      <View style={styles.section}>
                        <Text style={styles.label}>Arla (R$):</Text>
                        <Text style={styles.value}>
                          {NumberFormat(viagem.total_arla)}
                        </Text>
                      </View>
                      <View style={styles.section}>
                        <Text style={styles.label}>Comissão (R$):</Text>
                        <Text style={styles.value}>
                          {NumberFormat(viagem.total_comissao)}
                        </Text>
                      </View>
                      <View style={styles.section}>
                        <Text style={styles.label}>Descarga (R$):</Text>
                        <Text style={styles.value}>
                          {NumberFormat(viagem.total_descarga)}
                        </Text>
                      </View>
                      <View style={styles.section}>
                        <Text style={styles.label}>Outras Despesas (R$):</Text>
                        <Text style={styles.value}>
                          {NumberFormat(viagem.total_outros)}
                        </Text>
                      </View>
                      <View style={styles.section}>
                        <Text style={styles.label}>
                          Despesas Variáveis (R$):
                        </Text>
                        <Text style={styles.value}>
                          {NumberFormat(viagem.total_despesas)}
                        </Text>
                      </View>
                      <View style={styles.section}>
                        <Text style={styles.label}>
                          Resultado Líquido (R$):
                        </Text>
                        <Text style={styles.value}>
                          {NumberFormat(viagem.lucro)}
                        </Text>
                      </View>
                      <View style={styles.section}>
                        <Text style={styles.label}>Consumo/Receita (R$):</Text>
                        <Text style={styles.value}>
                          {NumberFormat(viagem.consumo_receita)}
                        </Text>
                      </View>
                      <View style={styles.section}>
                        <Text style={styles.label}>Despesa/Receita (R$):</Text>
                        <Text style={styles.value}>
                          {NumberFormat(viagem.despesa_receita)}
                        </Text>
                      </View>
                      <View style={styles.section}>
                        <Text style={styles.label}>Resultado Líquido (%):</Text>
                        <Text style={styles.value}>
                          {NumberFormat(viagem.lucro_bruto)}
                        </Text>
                      </View>
                    </View>
                  )
                )}
              </View>
            </>
          )}
        />
      ))}
    </Document>
  );
}

export default PDFContent;
